export default __webpack_public_path__ + "static/media/Crawle@2x.3296e2a7.png";